import { ApolloClient, InMemoryCache } from "@apollo/client";
import { mergeDeep } from "@apollo/client/utilities";
const ssrMode = typeof window === 'undefined';
const uri = ssrMode ? process.env.GRAPHQL_API : '/graphql';
const page_data = typeof window === 'undefined' ? undefined : window.ltg_page_data || {};
const header_data = typeof window === 'undefined' ? undefined : window.ltg_header_data || {};
const client = new ApolloClient({
    uri,
    cache: new InMemoryCache({
        typePolicies: {
            LayoutTemplate: {
                keyFields: ['template_id']
            },
        }
    }).restore(mergeDeep(page_data, header_data)),
    ssrMode,
});
export default client;
